import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import {NgClass, NgIf} from "@angular/common";
import {ContactService} from "../../../services/contact.service";
import {AppRoutes} from "../../../routing/app-routes.enum";
import {RouterLink} from "@angular/router";
import {RecaptchaService} from "../../../services/recaptcha.service";
import {ReturnPopinTypesEnum} from "../../../models/return-popin-types.enum";
import {ReturnPopinComponent} from "../return-popin/return-popin.component";  // Reuse your contact service

@Component({
  selector: 'app-cooptation-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgIf,
    NgClass,
    RouterLink,
    ReturnPopinComponent
  ],
  templateUrl: './cooptation-form.component.html',
  styleUrls: ['./cooptation-form.component.css']
})
export class CooptationFormComponent {
  cooptationForm: FormGroup;
  public readonly PORTAGILE_ROUTES_CGU: string = "/" + AppRoutes.CGU
  public readonly PORTAGILE_ROUTES_COOKIES: string = "/" + AppRoutes.COOKIES

  returnPopinMessage: string = "";
  returnType: ReturnPopinTypesEnum = ReturnPopinTypesEnum.NULL;

  constructor(private readonly recaptchaService: RecaptchaService, private contactService: ContactService, private fb: FormBuilder) {
    this.cooptationForm = this.fb.group({
      coopteur_nom: ['', Validators.required],
      coopteur_prenom: ['', Validators.required],
      coopteur_mail: ['', [Validators.required, Validators.email]],
      coopteur_telephone: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],

      cooptant_nom: ['', Validators.required],
      cooptant_prenom: ['', Validators.required],
      cooptant_mail: ['', [Validators.required, Validators.email]],
      cooptant_telephone: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],

      commentaire: ['', Validators.required],

      consent: [false, Validators.requiredTrue],
      cookiesConsent: [false, Validators.requiredTrue],
    });
  }

  onSubmit() {
    if (this.cooptationForm.valid) {
      this.recaptchaService.load("6Le4SnAqAAAAAEXpkk0d3_P6N91Dq6akwO2_3LyN")
        .then(() => {
          this.recaptchaService.execute('contactAction', recaptchaToken => {
            // Ajout du jeton reCAPTCHA aux données du formulaire
            const model = {
              ...this.cooptationForm.value,
              recaptchaToken
            };

            this.contactService.sendCooptation(model).subscribe({
              next: response => {
                console.log("Réponse du serveur :", response);
                this.returnPopinMessage=response.message
                this.returnType = ReturnPopinTypesEnum.SUCCESS;
                this.cooptationForm.reset();
              },
              error: error => {
                if (error.status === 429) {
                  console.error("Trop de requêtes : ", error);
                  this.returnPopinMessage="Vous avez fait trop de demandes. Veuillez patienter un moment avant de réessayer.";
                  this.returnType = ReturnPopinTypesEnum.WARNING;
                } else {
                  console.error("Erreur lors de l'envoi de la requête de cooptation :", error);
                  this.returnPopinMessage="Une erreur est survenue lors de l'envoi, veuillez réessayer plus tard.";
                  this.returnType = ReturnPopinTypesEnum.ERROR;
                }
              }
            });
          });
        })
        .catch(error => {
          console.error("Erreur lors du chargement de reCAPTCHA :", error);
          this.returnPopinMessage="Impossible de charger reCAPTCHA. Veuillez réessayer plus tard.";
          this.returnType = ReturnPopinTypesEnum.ERROR;
        });
    } else {
      console.log('Formulaire non valide');
    }
  }

  closeReturnPopin() {
    this.returnType = ReturnPopinTypesEnum.NULL;
    this.returnPopinMessage = "";
  }
}

